// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"25":"fdf2a0dd","161":"3ce82412","472":"3ab2b05a","480":"d239a4db","518":"a97a39c6"}[chunkId] + ".js";
};